import React from "react";
import "./WhyChooseUs.css";

const WhyChooseUs = () => {
  const reasons = [
    {
      title: "Product Portfolio of 3000+ Products",
      description:
        "We offer a wide range of over 3000 products across Gynae, Paediatric, Ortho, Cardiac-Diabetic, Derma & Ayurvedic divisions.",
    },
    {
      title: "Extensive Support",
      description:
        "Exceptional customer service, attractive product packaging, and highly competitive rates.",
    },
    {
      title: "Safe and Best-Quality Formulations",
      description:
        "Our clinically proven products are manufactured in WHO:GMP certified facilities ensuring safety and quality.",
    },
    {
      title: "Extensive Digital Assistance",
      description:
        "Expert digital marketing support through innovative advertising and social media campaigns.",
    },
  ];

  return (
    <section className="why-choose-us">
      <div className="w-container">
        <h2 className="section-title">Why Choose Trumac Healthcare?</h2>
        <div className="why-choose-content">
          {/* Left Column: 2x2 Grid */}
          <div className="left-column">
            <div className="reasons-grid">
              {reasons.map((reason, index) => (
                <div key={index} className="reason-item">
                  <div className="icon-container">
                    <svg
                      className="icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      ></path>
                    </svg>
                  </div>
                  <div className="reason-text">
                    <h3 className="reason-title">{reason.title}</h3>
                    <p className="reason-description">{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column: Full-height, Full-width Image */}
          <div className="right-column">
            <div className="image-wrapper">
              <img
                src="https://trumachealthcare.net/apiwha/why-choose-us.jpg"
                alt="Satisfied Partners"
                className="full-height-width-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
